module.exports = __webpack_public_path__ + "static/media/abfb593a.jpg";